export const MASTER_DATA = "master_data";
export const SYSTEM_DATA = "system_data";
export const AUTH = "auth";
export const PERMISSIONS = "permissions";
export const CONFIG = "config";
export const INVESTIGATION = "investigation";
export const USER_DATA = "user_data";
export const HOSPITAL_DATA = "hospital_data";
export const PRESCRIPTION_DOCTORS = "prescription_doctors";
export const DATES = "dates";
export const PATIENT_SEARCH_QUERIES = "patient_search_queries";
export const PATIENT_LIST_SEARCH_QUERIES = "patient_list_search_queries";
export const LAST_VISITED_PAGE = "last_visited_page";
export const LAST_VISITED_PATIENT_PAGE = "last_visited_patient_page";
export const SELECTED_ROW = "selected_row";
export const YEARS_TOTAL = 40;
export const RUPEE = "₹";
export const NOW = "NOW";
export const SCHEDULED = "SCHEDULE";
export const WHATSAPP_MKT_QUERY = "whatsapp_marketing_search_queries";
export const TEMPLATE_MKT_QUERY = "template_search_queries";
export const DIAGNOSIS = "diagnosis";
export const HOSPITAL_UNIT = "HOSPITAL_UNIT";
export const HOSPITAL_NOTIFICATION_CHANNELS = "hospital_notification_channels";
export const TEXTAREA_CHARACTER_LIMIT_1000 = 1000;
export const NOTES_SUGGESTION = "notes_suggestion";
export const COUNSELLING_REMARKS_SUGGESTION = "counselling_remarks_suggestion";
export const COUNSELLING_NOTES_SUGGESTION = "counselling_notes_suggestion";
